function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import { buttonColors } from "segments/button-service";
import { BRAND_BLACK_BACKGROUND_COLOR } from "styles/color-consts";
import HubspotContactFormAdvancedConfig from "../../../core-components/hubspot-contact-form/advanced-fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, SharedAdvancedFieldsConfig, HubspotContactFormAdvancedConfig), {
        disableShadow: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Disable shadow"
        },
        horizontalMargin: {
            type: FIELD_TYPES.TEXT,
            label: "Form horizontal margin"
        },
        mobileHorizontalPadding: {
            type: FIELD_TYPES.TEXT,
            label: "Mobile form horizontal padding"
        },
        maxWidth: {
            type: FIELD_TYPES.TEXT,
            label: "Form max width"
        },
        ctaProps: {
            type: FIELD_TYPES.NESTED,
            label: "CTA props",
            fields: {
                overrideText: {
                    type: FIELD_TYPES.TEXT,
                    label: "Override CTA text"
                },
                color: {
                    type: FIELD_TYPES.COLOR_PICKER,
                    label: "CTA color",
                    possibleColors: [
                        ...buttonColors,
                        BRAND_BLACK_BACKGROUND_COLOR
                    ]
                },
                invert: {
                    type: FIELD_TYPES.BOOLEAN,
                    label: "Outlined CTA"
                }
            }
        },
        privacyNoticeText: {
            type: FIELD_TYPES.TEXT,
            label: "Privacy notice text"
        },
        singleLineFieldBreakpoint: {
            type: FIELD_TYPES.TEXT,
            label: "Min screen width for enforced single line field (in px)"
        }
    })
};
